import React from 'react'
import { Link } from 'react-router-dom'

const Navbar = () => {
  return (
    <div className='navbar'>
      <nav className='navbar-ul'>
        <Link to='/links'>Links</Link>
        <Link to='/projects'>Projects</Link>
        <Link to='/video'>Video</Link>
        <Link to='/'>Home</Link>
      </nav>
    </div>
  )
}

export default Navbar
